"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LLM = void 0;
// eslint-disable-next-line import/prefer-default-export
var LLM = exports.LLM = 'llm';
//# sourceMappingURL=constants.js.map
